import axios from "axios";
import { getPSTDateTime } from "../../utils/helper";

// Add TypeScript declaration for gtag
declare global {
    interface Window {
        gtag: (command: string, action: string, params?: any) => void;
        fbq: (command: string, pixelId: string, event: string, params?: any) => void;
    }
}



export const triggerEmailStepZapier = (data: any) => {
    // Add submission date to data
    const dataWithDate = {
        ...data,
        submissionDate: getPSTDateTime()
    };

    // Fire and forget - don't await this call
    axios.post(
        "https://beta.caraccidentcounsel.com/api/zapier",
        dataWithDate,
        {
            headers: {
                "content-type": "application/json",
            },
        }
    ).catch(error => {
        // Silently handle errors to avoid disrupting user flow
        console.warn("Email step Zapier call failed:", error);
    });
};

export const submitQualifiedLead = async (data: any) => {
    await axios.post(
        "https://beta.caraccidentcounsel.com/api/phonexa",
        data,
        {
            headers: {
                "content-type": "application/json",
            },
        }
    );

    // Add submission date to data for Zapier
    const dataWithDate = {
        ...data,
        submissionDate: getPSTDateTime()
    };

    await axios.post(
        "https://beta.caraccidentcounsel.com/api/zapier",
        dataWithDate,
        {
            headers: {
                "content-type": "application/json",
            },
        }
    );

    // Add Google Tag Manager tracking
    if (typeof window !== 'undefined' && window.gtag) {
        // Set user data
        window.gtag('set', 'user_data', {
            "email": data.email,
            "phone_number": data.phone
        });

        // Send conversion event
        window.gtag('event', 'conversion', {
            'send_to': 'AW-606249212/Dr5FCLWbqdwBEPzBiqEC'
        });

        // Send conversion event
        window.gtag('event', 'conversion', {
            'send_to': 'AW-606249212/R23qCOnQ3NsBEPzBiqEC'
        });


    }

    if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('trackSingle', '1348720780180423', 'Lead');
    }

    if (data.Years === 0) {
        setTimeout(() => {
            window.location.href =
                `https://www.caraccidentcounsel.com/claim/survey-thank--you.php?email=${data.email}&were_you_injured_in_an_auto_accident=Yes&first_name=${data.firstName}&last_name=${data.lastName}&phone=${data.phone}&were_your_fault=${data.accidentFault}&years=${data.Years}&date=${data.date}`;
        }, 200);
    } else {
        setTimeout(() => {
            window.location.href =
                `https://www.caraccidentcounsel.com/claim/survey-thank-you.php`;
        }, 200);
    }


};

export const submitDequalifiedLead = async (data: any) => {
    const dequalData = {
        ...data,
        apiId: "5A0C65B3C3764D419506EC17623E2AC9",
        apiPassword: "b35db66ee8"
    };

    await axios.post(
        "https://beta.caraccidentcounsel.com/api/phonexa",
        dequalData,
        {
            headers: {
                "content-type": "application/json",
            },
        }
    );

    // Add submission date to dequalified data for Zapier
    const dequalDataWithDate = {
        ...dequalData,
        submissionDate: getPSTDateTime()
    };

    await axios.post(
        "https://beta.caraccidentcounsel.com/api/zapier",
        dequalDataWithDate,
        {
            headers: {
                "content-type": "application/json",
            },
        }
    );

    setTimeout(() => {
        window.location.href =
            `https://www.caraccidentcounsel.com/claim/survey-thank-you-dq.php?email=${dequalData.email}&were_you_injured_in_an_auto_accident=${dequalData.physicalInjury}&first_name=${dequalData.firstName}&last_name=${dequalData.lastName}&phone=${dequalData.phone}&were_your_fault=${dequalData.accidentFault}`;
    }, 200);
};